function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg width="36" height="36" viewBox="0 0 36 36" {...props}><path d="M18 35c9.389 0 17-7.611 17-17S27.389 1 18 1 1 8.611 1 18s7.611 17 17 17zm5.732-26.53l.243 4.248h-.622c0-.253-.109-.664-.327-1.233-.218-.57-.488-.995-.811-1.276a3.457 3.457 0 0 0-1.233-.685c-.478-.154-1.061-.232-1.75-.232H14.88l4.522 7.22-5.27 7.24h6.324c1.068 0 1.847-.12 2.34-.358.491-.24.81-.755.958-1.55h.601l-.548 4.901H11.233v-.695l5.733-7.884-5.702-8.99V8.47h12.468z" /></svg>;
});